// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aneV","content":"styles_content__9K76o"};